// Member feedback (migration 063): short "tell us" messages to the DSP Cafe
// team, read by moderators at /admin/feedback. Never shown to other members.
//
// Mirrors 063: FEEDBACK_TOPICS ↔ member_feedback_topic_check + submit_feedback's
// allowlist; FEEDBACK_MAX ↔ the message cap. Change both together.

export const FEEDBACK_MAX = 1000;

export const FEEDBACK_TOPICS = {
  mentorship: {
    label: 'Mentorship',
    title: 'What would you want from a mentor?',
    prompt: 'Anything helps: what you’d want to learn, what kind of DSP you’d want to be matched with, how often you’d want to talk.',
    placeholder: 'e.g. Someone who has worked overnights and can help me with documentation',
  },
};

// submit_feedback's errors, in words a member can act on.
export function feedbackErrorMessage(error) {
  const code = error?.message || '';
  if (code.includes('too_many')) return 'You’ve sent a few already today. Thank you! Try again tomorrow.';
  if (code.includes('message_too_long')) return `Please keep it under ${FEEDBACK_MAX} characters.`;
  if (code.includes('message_required')) return 'Write a few words first.';
  if (code.includes('not_authenticated')) return 'Your session expired. Sign in again and try once more.';
  return 'That didn’t send. Check your connection and try again.';
}
